module.exports = __webpack_public_path__ + "ab20302ffb39d38bcb24e6d53031de35.png";